import {
  LOGIN,
  LOGOUT,
  SET_ARTISAN
} from '../constants/ActionTypes';
import { stopSessionReplayRecording } from '../services/datadog';
import { getArtisan } from './proposition';
import notifSystem from '../notifSystem';
import store from '../store';

export function login(token) {
  return {
    type: LOGIN,
    token,
  };
}

export function logout() {
  window.localStorage.removeItem('token');
  stopSessionReplayRecording();
  return {
    type: LOGOUT
  };
}

/**
 * Récupère les informations de l'artisan connecté
 * @returns {Object} - Action Redux pour mettre à jour l'artisan dans le store
 */
export function setArtisan() {
  getArtisan()
    .then(artisanData => {
      store.dispatch({
        type: SET_ARTISAN,
        artisan: artisanData
      });
    })
    .catch(() => {
      notifSystem.error('Erreur', 'L\'artisan n\'a pas pu être récupéré');
    });
}
